let announcmenetBarSection = document.getElementById('shopify-section-announcement-bar')
let closeButton = document.getElementById('announcement-bar-close')
let bodyElement = document.body;

document.addEventListener("DOMContentLoaded", (event) => { 
    if (closeButton) {
        closeBarIfHidden()
    }
})

if (closeButton != null) {
    closeButton.addEventListener('click', () => {
        localStorage.setItem('announcementBarClosed', true)
        closeBarIfHidden()
    })
}

let closeBarIfHidden = () => {
    if(localStorage.getItem('announcementBarClosed')) {
        bodyElement.classList.add('announcement-bar-hidden')
    }
}
